import React, { useEffect } from 'react';
import useClearPlaylist from '../../hooks/clearPlaylistOnLoad';
import { UploadsDisplay } from '../Uploads/UploadsDisplay/UploadsDisplay';
import useVideoListings from '../../hooks/videoListings';

export function Approve() {
  useClearPlaylist();

  const { refreshVideosAwaitingApproval } = useVideoListings();

  useEffect(() => {
    refreshVideosAwaitingApproval();
  }, []);

  return (
    // Wrapper required as kitbag-component card specifies height
    <div>
      <UploadsDisplay onRefresh={refreshVideosAwaitingApproval} />
    </div>
  );
}

export default { Approve };
